// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';
import { Link } from 'react-router';

import { Icons } from '../../../../web-utils/src/UI/Component/React/V1/Icons/Icons';

export const Footer = () => {
  return (
    <ul>
      <li style={{ display: 'flex', columnGap: 'var(--spacing-2)' }}>
        <Icons iconType='support' />
        <Link to={'https://support.mo-sys.com'} rel='noopener noreferrer' target='_blank'>
          Support
        </Link>
      </li>
    </ul>
  );
};
